import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <nav className="social-bar">
        <h2 className="footer-title">Siga-nos no instagram:</h2>
        <a href="https://www.instagram.com/unidunite__kids/" target='_blank' rel="noreferrer">
          <img
            src="https://i.postimg.cc/sDHrwTTd/insta-logoinsta-icon.png"
            alt="instagram-icon"
          />
        </a>
      </nav>
      <address className="address-info">
        <h4>Nossos contatos:</h4>
        <p>telefone: (87)9.9642-0559</p>
        <p>instagram: unidunite__kids</p>
        <p>Caetés - PE</p>
      </address>
        <p className="written-by">Written by Romildo Silva, romildo.silvafilho1@gmail.com</p>
    </footer>
  )
}

export default Footer